export default {
  setSummary(state, payload) {
    state.summary = payload || { branches: [], clients: [] };
  },
  setSelectedEntity(state, entity) {
    state.selectedEntity = entity;
  },
  setEntries(state, payload) {
    state.entries = payload.entries || [];
    state.pagination = payload.pagination || state.pagination;
  },
  setBalance(state, payload) {
    state.balance = {
      settled: Number(payload?.settled) || 0,
      unsettledAccrual: Number(payload?.unsettledAccrual) || 0,
      live: Number(payload?.live) || 0,
      unsettledBreakdown: payload?.unsettledBreakdown || {
        payinAmount: 0,
        payinCount: 0,
        payoutAmount: 0,
        payoutCount: 0,
        payinCommission: 0,
        payoutCommission: 0,
      },
      unsettledWindowStart: payload?.unsettledWindowStart || null,
    };
  },
  setCategories(state, list) {
    state.categories = list || [];
  },
};
